import {useCallback, useMemo, useRef} from "react";

const useHumanWheelChecker = () => {
    const lastHumanEventTime = useRef<number>(0);
    const lastEventTime = useRef<number>(0);
    const lastEventDelta = useRef<number>(0);

    const ScrollTermTresHold = 150;
    const HumanScrollTermTresHold = 300;
    const UpwardScrollDiffTresHold = 2;

    const getScrollDelta = useCallback((e: React.WheelEvent, type: "x" | "y" | undefined) => {
        const scrollX = Math.abs(e.deltaX);
        const scrollY = Math.abs(e.deltaY);

        switch(type) {
            case "x":
                return scrollX > scrollY ? scrollX : undefined
            case "y":
                return scrollX < scrollY ? scrollY : undefined
            default:
                return Math.max(scrollX, scrollY)
        }


    }, [])

    const check = useCallback((e: React.WheelEvent, type?: "x" | "y") => {
        const currentTime = performance.now();
        const scrollDelta = getScrollDelta(e, type);
        if (scrollDelta === undefined) return false;

        let isHuman: boolean;

        if (lastEventTime.current + ScrollTermTresHold < currentTime){
            isHuman = true;
        } else if (lastEventDelta.current + UpwardScrollDiffTresHold >= scrollDelta) {
            isHuman = false;
        } else {
            isHuman = lastHumanEventTime.current + HumanScrollTermTresHold <= currentTime
        }

        lastEventTime.current = currentTime;
        lastEventDelta.current = scrollDelta;
        if (isHuman) {
            lastHumanEventTime.current = currentTime;
        }
        return isHuman
    }, [getScrollDelta])

    return useMemo(() => {
        return { check }
    }, [check])
}

export default useHumanWheelChecker;
